/**
 * Keyboard rules for the Kanban board, free of Vue and DHTMLX so they can be unit-tested.
 */

/** What the board does with a key press. */
export const DELETE_SHORTCUT = Object.freeze({
  /** Not the board's key: leave it to whoever else listens. */
  IGNORE: 'ignore',
  /** The board's key, but the user may not delete tasks. */
  DENIED: 'denied',
  /** Delete the selected cards (after the usual confirm). */
  DELETE: 'delete',
});

const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

/** Delete, or Cmd+Backspace (a Mac keyboard has no forward Delete key). */
export function isDeleteShortcut(event) {
  return event.key === 'Delete' || (event.key === 'Backspace' && !!event.metaKey);
}

/** Whether the key press is text editing, which must never delete cards. */
export function isEditableTarget(target) {
  if (!target) return false;
  return EDITABLE_TAGS.includes(target.tagName) || !!target.isContentEditable;
}

/**
 * Decide a key press for the board.
 * @param {KeyboardEvent} event
 * @param {{ active: boolean, boardFocused: boolean, canDelete: boolean }} context
 *   active: the Kanban is the visible tab (keep-alive keeps it alive behind the others);
 *   boardFocused: the user's last pointer or focus event was inside the board;
 *   canDelete: the user holds the task delete permission.
 */
export function deleteShortcutDecision(event, { active, boardFocused, canDelete }) {
  if (!isDeleteShortcut(event) || !active || !boardFocused || isEditableTarget(event.target)) {
    return DELETE_SHORTCUT.IGNORE;
  }
  return canDelete ? DELETE_SHORTCUT.DELETE : DELETE_SHORTCUT.DENIED;
}
